(function(){
  'use strict';

  // 计算总页数：优先使用 data-count/data-size 自动计算，否则使用 data-total
  function getTotalPages(root){
    var count=Number(root.dataset.count||0);
    var size=Number(root.dataset.size||10);
    if(count>0 && size>0){
      var total=Math.ceil(count/size);
      return total<1 ? 1 : total;
    }
    return Number(root.dataset.total||1);
  }

  function buildPages(current,total){
    var pages=[];
    if(total<=5){
      for(var i=1;i<=total;i++) pages.push(i);
      return {pages:pages, ellipsis:false};
    }
    // >5: 展示 1 2 3 4 ... total，从第5页开始缩略
    if(current<5){
      pages=[1,2,3,4];
    } else {
      pages=[current-2,current-1,current];
      // 确保不小于2
      pages=pages.filter(function(n){return n>=2;});
      pages.unshift(1);
    }
    // 保证最后一页
    if(pages[pages.length-1]!==total) pages.push(total);
    // 去重并排序
    pages=Array.from(new Set(pages)).sort(function(a,b){return a-b;});
    return {pages:pages, ellipsis:true};
  }

  function render(root){
    var current=Number(root.dataset.current||1);
    var total=getTotalPages(root);
    // 同步更新 data-total 属性
    root.dataset.total=String(total);
    var pagesWrap=root.querySelector('[data-pages]');
    pagesWrap.innerHTML='';

    var prevBtn=root.querySelector('[data-prev]');
    prevBtn.setAttribute('aria-disabled', current<=1 ? 'true' : 'false');

    var nextBtn=root.querySelector('[data-next]');
    nextBtn.setAttribute('aria-disabled', current>=total ? 'true' : 'false');

    var info=buildPages(current,total);
    var last=-1;
    info.pages.forEach(function(n){
      if(last>0 && n-last>1){
        var span=document.createElement('span');
        span.className='paginator__ellipsis';
        span.textContent='…';
        pagesWrap.appendChild(span);
      }
      last=n;
      var btn=document.createElement('button');
      btn.className='paginator__page';
      btn.textContent=String(n);
      if(n===current) btn.setAttribute('aria-current','true');
      btn.addEventListener('click',function(){
        if(n===current) return;
        root.dataset.current=String(n);
        dispatchChange(root);
        render(root);
      });
      pagesWrap.appendChild(btn);
    });
  }

  function dispatchChange(root){
    var current=Number(root.dataset.current||1);
    var total=getTotalPages(root);
    var size=Number(root.dataset.size||10);
    var count=Number(root.dataset.count||0);
    root.dispatchEvent(new CustomEvent('paginator:change',{bubbles:true,detail:{current:current,total:total,size:size,count:count}}));
  }

  function init(root){
    if(root._inited) return; root._inited=true;
    var prevBtn=root.querySelector('[data-prev]');
    var nextBtn=root.querySelector('[data-next]');
    prevBtn.addEventListener('click',function(){
      var c=Number(root.dataset.current||1); if(c<=1) return; root.dataset.current=String(c-1); dispatchChange(root); render(root);
    });
    nextBtn.addEventListener('click',function(){
      var c=Number(root.dataset.current||1);
      var t=getTotalPages(root);
      if(c>=t) return; root.dataset.current=String(c+1); dispatchChange(root); render(root);
    });
    render(root);
  }

  function auto(){
    document.querySelectorAll('[data-component="paginator"]').forEach(init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',auto); else auto();
  window.initPaginatorComponents=auto;
  window.refreshPaginatorComponent=render;
  document.dispatchEvent(new CustomEvent('paginator:ready'));
})();


